export const SESSION_ITEM_USER_SESSION_ID = 'user_sessionId';
export const SESSION_ITEM_ACCESS_TOKEN = 'oauth_accessToken';
export const SESSION_ITEM_ID_TOKEN = 'oauth_idToken';
export const SESSION_ITEM_REFRESH_TOKEN = 'oauth_refreshToken';
export const SESSION_ITEM_CODE_VERIFIER = 'oauth_codeVerifier';
export const SESSION_ITEM_STATE = 'oauth_state';
export const SESSION_ITEM_REDIRECT = 'oauth_postLoginRedirectPath';
export const SESSION_ITEM_SILENT_AUTH_ATTEMPTED = 'oauth_silentAttempted';
export const SESSION_ITEM_CHECK_AUTH_DISABLED = 'oauth_checkAuthDisabled';
export const SESSION_ITEM_SSO_LOGGED_IN = 'sso_logged_in';
export const SESSION_ITEM_SSO_TOKEN = 'sso_token';
